import { ConvertedRecommendItem, RecommendItem } from '~/types/common/silverEgg';

// シルバーエッグから取得した商品を、ECと同じ型に変換する
export const convertRecommendItems = (
  silverEggItems: Array<RecommendItem>,
  isFood = false
): Array<ConvertedRecommendItem> =>
  silverEggItems.map((item: RecommendItem) => {
    return {
      code: item._id,
      catchCopy: '', // 現状表示不要
      image: item.img_url,
      detail_url: item.ct_url,
      product: {
        name: item.title,
        color: item.label || '',
        producing_area: {
          area_1: item.country_name_eventdate,
          area_id_1: item.country_id,
          area_2: item.area_shop_name !== item.country_name_eventdate ? item.area_shop_name : '', // area_shop_nameは最も子の生産地名
          area_3: undefined,
          /** 第一階層の生産地名＋第二階層の生産地名 */
          area_full:
            item.region_name && item.country_name_eventdate !== item.region_name
              ? `${item.country_name_eventdate} ${item.region_name}`
              : item.country_name_eventdate,
        },
        grape: item.grape_varieties,
        producer: item.producer_name,
        review_average: Number(item.review_point),
        display_price: item.special_price_string || item.price_string,
        special_price: item.special_price_string,
        is_free_shipping: item.is_free_shipping,
        is_discount: Number(item.discount_rate) > 0,
        discount_rate: Number(item.discount_rate),
        sale_label: item.sale_promotion_info,
      },
      isSeFood: isFood,
      variantCode: undefined,
      categories: item.cats,
    };
  });

// カテゴリの正規表現
const COLOR_PATTERN = /^color[0-9]+$/;
const PARENT_AREA_PATTERN = /^area_(?!all$)[a-zA-Z]+$/;
const CHILD_AREA_PATTERN = /^area_[a-zA-Z]+_[a-zA-Z0-9]+$/;
const GRAPE_PATTERN = /^grape_(?!all$)[a-zA-Z]+$/;
const PRODUCER_PATTERN = /^producer_(?!all$)[a-zA-Z0-9]+$/;

/** パーソナライズTOPに必要なカテゴリを取得 */
export const getPersonalizedCategories = (categories: ConvertedRecommendItem['categories'] = []) => {
  /** 色タイプ */
  const color = categories.find((category) => COLOR_PATTERN.test(category)) || '';
  /** 親産地 */
  const parentArea = categories.find((category) => PARENT_AREA_PATTERN.test(category)) || '';
  /** 子産地 */
  const childArea = categories.find((category) => CHILD_AREA_PATTERN.test(category)) || '';
  /** 品種 */
  const grape = categories.find((category) => GRAPE_PATTERN.test(category)) || '';
  /** 生産者 */
  const producer = categories.find((category) => PRODUCER_PATTERN.test(category)) || '';

  return {
    color,
    area: childArea || parentArea,
    grape,
    producer,
  };
};
